import { render, staticRenderFns } from "./ModelUpgrade.vue?vue&type=template&id=59f21d90&scoped=true&"
import script from "./ModelUpgrade.vue?vue&type=script&lang=js&"
export * from "./ModelUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./ModelUpgrade.vue?vue&type=style&index=0&id=59f21d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f21d90",
  null
  
)

export default component.exports